import React from 'react';
import {
  Form, Input, Button, DatePicker, Upload, Card, Space, Switch, message, Image
} from 'antd';
import axios from 'axios';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

class NewsForm extends React.Component {
  formRef = React.createRef();

  state = {
    contentBlocks: [],
  };

  componentDidMount() {
    this.initForm();
  }

  componentDidUpdate(prevProps) {
    // 检查是否是新的编辑对象    
    if (this.props.initialData?.id !== prevProps.initialData?.id) {
      this.initForm();
    }
  }

  initForm = () => {
    const { initialData } = this.props;
  
    let contentBlocks = [];
    if (initialData?.contentBlocks) {
      if (typeof initialData.contentBlocks === 'string') {
        try {
          contentBlocks = JSON.parse(initialData.contentBlocks);
        } catch (e) {
          console.error('contentBlocks JSON parse failed:', e);
        }
      } else if (Array.isArray(initialData.contentBlocks)) {
        contentBlocks = initialData.contentBlocks;
      }
    }
  
    this.formRef.current?.setFieldsValue({
      ...initialData,
      publishTime: initialData?.publishTime ? dayjs(initialData.publishTime) : null,
      status: initialData?.status === 1,
    });
  
    this.setState({
      contentBlocks,
    });
  };
  

  handleAddBlock = () => {
    this.setState(prev => ({
      contentBlocks: [...prev.contentBlocks, {
        imageUrl: '', imageCaption: '', contentText: ''
      }]
    }));
  };

  handleBlockChange = (index, field, value) => {
    console.log(value,'value');
    
    const updated = [...this.state.contentBlocks];
    updated[index][field] = value;
    updated[index]['imageCaption'] = value;

    this.setState({ contentBlocks: updated });
  };

  // handleUpload = (index, file) => {
  //   const url = URL.createObjectURL(file);

  //   this.handleBlockChange(index, 'imageUrl', url);
  //   return false;
  // };
  handleUpload = async (index, file) => {
    const formData = new FormData();
    formData.append('files', file); // 文件字段
    formData.append('name', 'files'); // 附带字段
    formData.append('formData', JSON.stringify({})); // 附带字段（空对象）
  
    try {
      const response = await axios.post(
        'http://333.shulan-tech.com/file/uploadToServer',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      const result = response.data;
  
      if (result.code == 200) {
        this.handleBlockChange(index, 'imageUrl', 'https://444.shulan-tech.com' + result.filePaths[0]);
      } else {
        console.error('上传失败：', result.message);
      }
    } catch (error) {
      console.error('上传出错：', error);
    }
  
    return false;
  };

  onFinish = (values) => {
    const data = {
      ...values,
      contentBlocks: this.state.contentBlocks,
      publishTime: values.publishTime?.format('YYYY-MM-DD'),
      status: values.status ? 1 : 0,
    };
    this.props.onSubmit(data);
  };

  render() {
    const { onCancel } = this.props;
    const { contentBlocks } = this.state;
    console.log(contentBlocks,'contentBlocks');
    

    return (
      <Form
        layout="vertical"
        onFinish={this.onFinish}
        ref={this.formRef}
      >
        <Form.Item label="主标题" name="mainTitle" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="标题简介" name="subTitle">
          <Input />
        </Form.Item>

        <Form.Item label="内容区块">
          {contentBlocks.length>0 && contentBlocks.map((block, index) => (
            <Card key={index} style={{ marginBottom: 16 }}>
              <Form.Item label="上传图片">
                <Upload
                  beforeUpload={file => this.handleUpload(index, file)}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />}>上传</Button>
                </Upload>

                {block.imageUrl && <Image src={block.imageUrl} preview={true} style={{ width: 100, marginTop: 10, marginLeft: 10 }} />}
              </Form.Item>
              <Form.Item label="图片地址">
                <Input value={block.imageCaption} onChange={e => this.handleBlockChange(index, 'imageCaption', e.target.value)} />
              </Form.Item>
              <Form.Item label="文本内容">
                <Input.TextArea value={block.contentText} onChange={e => this.handleBlockChange(index, 'contentText', e.target.value)} />
              </Form.Item>
            </Card>
          ))}
          <Button onClick={this.handleAddBlock} icon={<PlusOutlined />}>添加内容块</Button>
        </Form.Item>

        <Form.Item label="结尾文字" name="closingText">
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="时间" name="publishTime">
          <DatePicker />
        </Form.Item>

        {/* <Form.Item label="状态" name="status" valuePropName="checked">
          <Switch checkedChildren="启用" unCheckedChildren="停用" />
        </Form.Item> */}

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">保存</Button>
            <Button onClick={onCancel}>取消</Button>
          </Space>
        </Form.Item>
      </Form>
    );
  }
}

export default NewsForm;

